<template>

  <v-container fluid class="pa-0" style="background:#f6f6f6">

    <v-row class="ml-5" align="center" dense>
      <v-col cols="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
    </v-row>

    <v-row >

    <v-col md="3" sm="12" xs="12" >
      <v-row dense no-gutters>
        <v-col cols="6">
          <v-text-field 
            dense single-line clearable
            @keyup.enter="search_run" 
            v-model="search_keyword" 
            :placeholder="$t('common_search_holder')"
            outlined height="43"
            color="#808080"
            hide-details
            class="ml-5"
            />
        </v-col>
        <v-col cols="6">
          <v-btn class="search_btn mx-1" elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
          <v-btn class="search_btn" elevation="0" outlined large @click="newlayout">{{$t('adminlayout_label1')}}</v-btn>
        </v-col>
      </v-row>

      <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="20"
          :no-data-text="$t('design_msg11')"
          :no-results-text="$t('design_msg12')"
          class="datatablestyle ml-5 mr-5 mt-2"
          item-key="name"
          hide-default-footer
          :loading="loading"
          >

          <template v-slot:header.LAYOUT_NAME>
            <label class="cheader_normal" >{{$t("adminlayout_col1")}}</label>
          </template>
          <template v-slot:header.COMPONENT_WIDTH>
            <label class="cheader_normal" >{{$t("adminlayout_col2")}}</label>
          </template>
          <template v-slot:header.COMPONENT_HEIGHT>
            <label class="cheader_normal" >{{$t("adminlayout_col3")}}</label>
          </template>
          <template v-slot:header.detail>
            <label class="cheader_normal" >{{$t("adminlayout_col4")}}</label>
          </template>
                                        
        <template v-slot:item.detail="{item}">
          <v-icon class="mr-2" small @click="loaddetail(item)">mdi-pencil</v-icon>
            <v-icon class="mr-2" small @click="delete_item(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>

      <!-- 하단 페이징 영역 -->
        <v-col cols="12" md="12" class="d-flex justify-center">
          <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
          <span v-for="n in subpage" :key="n.id">
              <span v-if="page == bottompage-1+n">
                  <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
              </span>
              <span v-else>
                  <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
              </span>
          </span>
          <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
        </v-col>

      </v-col>


      <v-col style="background:white; border-style:solid; border-width:0px 2px 0px 0px;border-color:#f2f2f2" v-if="PARENT_ITEM.ADMIN_IDX != null" cols="12" md="6" sm="12" xs="12">

        <v-row ref="edit_layout" justify="center" dense no-gutters>
            <v-col cols="3">
              <v-text-field background-color="white" dense outlined height="43" ref="ref_diswidth" :value="DISPLAY_WIDTH" :label="$t('design_label1')" @keydown.enter="changedisplay"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field background-color="white" dense outlined height="43" ref="ref_disheight" :value="DISPLAY_HEIGHT" :label="$t('design_label2')" @keydown.enter="changedisplay"></v-text-field>
            </v-col>
            <v-btn class="white_blue_btn ml-2" outlined large @click="changedisplay">{{$t('design_label21')}}</v-btn>
            <v-btn class="white_blue_btn ml-2" outlined large @click="savedesign"><v-icon>mdi-download</v-icon>{{$t("common_save")}}</v-btn>
        </v-row>

        <!-- 저장 완료 Toast -->
        <v-snackbar
          v-model="showSaveSnackbar"
          timeout="3000"
          color="success"
          top
        >
          {{$t('design_msg3')}}
          <template v-slot:action="{ attrs }">
            <v-btn
              color="white"
              text
              v-bind="attrs"
              @click="showSaveSnackbar = false"
            >
            </v-btn>
          </template>
        </v-snackbar>

        <v-row class="mt-5" justify="center" dense no-gutters>
          
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="addcomponent" v-bind="attrs" v-on="on"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
              </template>
              <span>{{$t("common_insert")}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="centeralign" v-bind="attrs" v-on="on"><v-icon>mdi-align-horizontal-center</v-icon></v-btn>
              </template>
              <span>{{$t('design_label5')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="!SELECT_ITEM || SELECT_ITEM.length == 0 || SELECT_ITEM[0].ISBG == 1" icon color="#505050" @click="rotateComponent" v-bind="attrs" v-on="on"><v-icon>mdi-rotate-right</v-icon></v-btn>
              </template>
              <span>{{$t("common_rotate")}}</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="fullsize" v-bind="attrs" v-on="on"><v-icon>mdi-arrow-split-vertical</v-icon></v-btn>
              </template>
              <span>{{$t('design_label6')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="getfront" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-bring-forward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label7')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="pushback" v-bind="attrs" v-on="on"><v-icon>mdi-arrange-send-backward</v-icon></v-btn>
              </template>
              <span>{{$t('design_label8')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="deleteall" v-bind="attrs" v-on="on"><v-icon>mdi-autorenew</v-icon></v-btn>
              </template>
              <span>{{$t('design_label9')}}</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="#505050" @click="deletedesign" v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
              </template>
              <span>{{$t('design_label10')}}</span>
            </v-tooltip>
          
        </v-row>

        <v-row justify="center" dense no-gutters>
          <div id="edit_div_line" :style="'margin-left:20px;width:'+(DISPLAY_WIDTH+6)+'px;height:'+(DISPLAY_HEIGHT+6)+'px;backgroundColor:#808080;overflow:auto;position:absolute;border:solid 3px #4e6ef7;'">
            <div id="edit_div" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;'">
            </div>
          </div> 
        </v-row>
        
      </v-col>


      <v-col style="background:white" v-if="PARENT_ITEM.ADMIN_IDX != null" cols="12" md="3" sm="12" xs="12">
        
        <v-row class="ml-5 mr-5" dense>
          <v-text-field outlined v-model="PARENT_ITEM.LAYOUT_NAME" 
          @input="changesize" @change="changesize" :label="$t('adminlayout_col1')"
          hide-details dense
          />
          
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <comlayout @callback="selectlayout_com"/>
          </v-col>
        </v-row>

        <template v-if="SELECT_ITEM && SELECT_ITEM.length > 0 && SELECT_ITEM[0]">
        <template v-if="SELECT_ITEM[0].ISBG == 0">
          <v-row dense class="mt-2 ml-5 mr-5">
            <v-select outlined dense :value="SELECT_ITEM[0].COMPONENT_TYPE" @change="changecomponenttype" :items="COMPONENTTYPELIST" :label="$t('design_label13')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
          </v-row>
        </template>
        <v-row dense class="mt-2 ml-5 mr-5">
          <v-select outlined dense :value="SELECT_ITEM[0].BGTYPE" @change="changebgtype" :items="BGTYPELIST" :label="$t('design_label14')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
        </v-row>

        <template v-if="SELECT_ITEM[0].BGTYPE == 1">
          <v-row dense class="ml-5 mr-5">
            <v-file-input dense accept="image/*" :label="$t('design_label15')" v-model="uploadFile" @change="changefile">
              <!-- <template v-slot:selection>{{ SELECT_ITEM[0].LOCALIMG }}</template> -->
            </v-file-input>
            <template v-if="SELECT_ITEM[0].LOCALIMG != null ">
              <v-btn class="search_btn" small rounded color="primary" @click="uploadimage">{{$t("common_save")}}</v-btn>
            </template>
          </v-row>
        </template>

        <v-row dense class="ml-5 mr-5">
          <comcolor :disabled="SELECT_ITEM[0].BGTYPE == 1" dense ref="bgcolor" :comname="$t('design_label16')" :colorvalue="SELECT_ITEM[0].BGCOLOR" @callback="bgcolorcallback" />
        </v-row>

        <v-row dense class="ml-5 mr-5">
          <comcolor :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense ref="textcolor" :comname="$t('design_label17')" :colorvalue="SELECT_ITEM[0].TEXTCOLOR" @callback="textcolorcallback" />
        </v-row>
        <v-row dense class="mt-2 ml-5 mr-5">
          <v-select outlined :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" dense :value="SELECT_ITEM[0].TEXTALIGN"  @change="changealign" :items="ALIGNTYPELIST" :label="$t('design_label19')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
        </v-row>
        <v-row dense class="ml-2 mr-5">
          <comfont :comidx="null" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :comname="SELECT_ITEM[0].TEXTFONT" @callback="changefont"/>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field outlined dense height="43" ref="ref_textsize" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTSIZE" @change="changesize" :label="$t('design_label20')" @keydown.enter="changesize"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changesize">{{$t('design_label21')}}</v-btn>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-select outlined dense :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTMATCH" @change="changematch" :items="MATCHTYPELIST" :label="$t('design_label22')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-textarea outlined dense height="70" no-resize ref="ref_textvalue" :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" :value="SELECT_ITEM[0].TEXTVALUE" @change="changevalue" :label="$t('design_label23')" @keydown.enter="changevalue"></v-textarea>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1 || SELECT_ITEM[0].COMPONENT_TYPE == 0" class="ml-2 search_btn" @click="changevalue">{{$t('design_label21')}}</v-btn>
        </v-row>

        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field dense outlined height="43" ref="ref_posx" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].TEMP_POSX" @change="changeposx" :label="$t('design_label24')" @keydown.enter="changeposx"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeposx">{{$t('design_label21')}}</v-btn>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field dense outlined height="43" ref="ref_posy" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].TEMP_POSY" @change="changeposy" :label="$t('design_label25')" @keydown.enter="changeposy"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeposy">{{$t('design_label21')}}</v-btn>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field dense outlined height="43" ref="ref_width" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_WIDTH" @change="changewidth" :label="$t('design_label26')" @keydown.enter="changewidth"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changewidth">{{$t('design_label21')}}</v-btn>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field dense outlined height="43" ref="ref_height" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].LAYOUT_HEIGHT" @change="changeheight" :label="$t('design_label27')" @keydown.enter="changeheight"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changeheight">{{$t('design_label21')}}</v-btn>
        </v-row>
        <v-row dense class="ml-5 mr-5">
          <v-col class="ma-0 pa-0">
            <v-text-field dense outlined height="43" ref="ref_rotate" :disabled="SELECT_ITEM[0].ISBG == 1" :value="SELECT_ITEM[0].ROTATE" @change="changerotate" :label="$t('design_label28')" @keydown.enter="changerotate"></v-text-field>
          </v-col>
          <v-btn :disabled="SELECT_ITEM[0].ISBG == 1" class="ml-2 search_btn" @click="changerotate">{{$t('design_label21')}}</v-btn>
        </v-row>
        </template>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground2.js'
import DRComponent from '../dragndrop/DRComponent2.js'
import DRModel from '../dragndrop/DRModel.js'

  export default {

    methods: {


      async newlayout(){

        //해당 값이 들어가야 edit_div가 보여진다.
        this.PARENT_ITEM = {};
        this.PARENT_ITEM.ADMIN_IDX = this.$session.get("ADMIN_IDX");
        this.PARENT_ITEM.LAYOUT_NAME = this.$t('adminlayout_label2');

        this.DISPLAY_WIDTH  = 384;
        this.DISPLAY_HEIGHT = 463;

        setTimeout(() => {  
          const edit_div = document.getElementById("edit_div");
          while ( edit_div.hasChildNodes() ) {
            edit_div.removeChild( edit_div.firstChild ); 
          }

          const bg = new DRModel();
          bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
          bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
          bg.LAYOUT_POSX    = 0;
          bg.LAYOUT_POSY    = 0;
          bg.ISBG           = 1;  //bg
          bg.COMPONENT_TYPE = 0; 
          bg.BGTYPE = 0;
          bg.BGCOLOR = "FFFFFFFF";
          bg.TEXTCOLOR = "000000FF";
          bg.TEXTALIGN = "CENTER";
          bg.TEXTFONT = "나눔고딕";
          bg.TEXTSIZE = 20;
          bg.TEXTMATCH = "INPUT";
          bg.TEXTVALUE = "";
          bg.TEMP_POSX = 0;
          bg.TEMP_POSY = 0;
          bg.TEMP_WIDTH = this.DISPLAY_WIDTH;
          bg.TEMP_HEIGHT = this.DISPLAY_HEIGHT;
          bg.ROTATE = 0;
          bg.LOCALIMG = null;
          
          this.SELECT_ITEM.splice(0, 1, bg);
          this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
          edit_div.appendChild(this.drback);
        }, 1000);

      },

      fullsize(){
        this.drback.fullsize();
      },

      centeralign(){
        this.drback.centeralign();
      },

      getfront(){
        this.drback.getfront();
      },

      pushback(){
        this.drback.pushback();
      },
      
      //명찰편집 이벤트
      changeposx(){
        let inputEl = this.$refs.ref_posx.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].TEMP_POSX = 0;
        }else{
          this.SELECT_ITEM[0].TEMP_POSX = parseInt(ev);
        }
        this.drback.updateComponent();
      },
      changeposy(){
        let inputEl = this.$refs.ref_posy.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].TEMP_POSY = 0;
        }else{
          this.SELECT_ITEM[0].TEMP_POSY = parseInt(ev);
        }
        this.drback.updateComponent();
      },
      changewidth(){
        let inputEl = this.$refs.ref_width.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_WIDTH = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_WIDTH = parseInt(ev);
        }
        this.drback.updateComponent();
      },
      changeheight(){
        let inputEl = this.$refs.ref_height.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        if(isNaN(parseInt(ev))){
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = 0;
        }else{
          this.SELECT_ITEM[0].LAYOUT_HEIGHT = parseInt(ev);
        }
        this.drback.updateComponent();
      },

      changerotate(){
        let inputEl = this.$refs.ref_rotate.$el.querySelector('input');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        if(isNaN(parseFloat(ev))){
          this.SELECT_ITEM[0].ROTATE = 0;
        }else{
          this.SELECT_ITEM[0].ROTATE = parseFloat(ev);
        }
        this.drback.updateComponent();
      },

      rotateComponent(){
        if(this.SELECT_ITEM && this.SELECT_ITEM.length > 0 && this.SELECT_ITEM[0].ISBG != 1){
          this.drback.saveUndo("info");
          // 현재 회전값에서 90도씩 추가 (360도 넘으면 0부터 시작)
          let currentRotate = this.SELECT_ITEM[0].ROTATE || 0;
          this.SELECT_ITEM[0].ROTATE = (currentRotate + 90) % 360;
          this.drback.updateComponent();
          this.$forceUpdate(); // 화면 갱신
        }
      },

      // Del 키 이벤트 핸들러
      handleKeyDown(event){
        // Del 키 또는 Delete 키가 눌렸을 때
        if(event.key === 'Delete' && this.SELECT_ITEM && this.SELECT_ITEM.length > 0 && this.SELECT_ITEM[0].ISBG != 1){
          event.preventDefault(); // 기본 동작 방지
          this.deletedesign(); // 기존 삭제 메서드 호출
        }
      },

      changedisplay(){
        let inputEl1 = this.$refs.ref_diswidth.$el.querySelector('input');
        var ev1 = inputEl1.value;
        if(isNaN(parseInt(ev1))){
          this.DISPLAY_WIDTH = 0;
        }else{
          this.DISPLAY_WIDTH = parseInt(ev1);
        }
        let inputEl2 = this.$refs.ref_disheight.$el.querySelector('input');
        var ev2 = inputEl2.value;
        if(isNaN(parseInt(ev2))){
          this.DISPLAY_HEIGHT = 0;
        }else{
          this.DISPLAY_HEIGHT = parseInt(ev2);
        }
        this.drback.setLayoutChange(this.DISPLAY_WIDTH, this.DISPLAY_HEIGHT);
        this.drback.updateComponent();
      },

      changevalue(){
        let inputEl = this.$refs.ref_textvalue.$el.querySelector('textarea');
        var ev = inputEl.value;
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTVALUE = ev;
        this.drback.updateComponent();
      },
      changesize(){
        let inputEl = this.$refs.ref_textsize.$el.querySelector('input');
        var ev = inputEl.value;
        if(ev < 10){
          this.$alert(this.$t('design_msg1'));
          inputEl.value = this.SELECT_ITEM[0].TEXTSIZE;
          return;
        }
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTSIZE = parseInt(ev);
        this.drback.updateComponent();
      },
      changealign(ev){
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTALIGN = ev;
        this.drback.updateComponent();
      },
      changematch(ev){
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTMATCH = ev;
        this.drback.updateComponent();
      },

      changefont(cl){
        //폰트 변경
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTFONT = cl.CODE;
        this.drback.updateComponent();
        this.$forceUpdate();
      },

      changebgtype(cl){
        
        if(this.SELECT_ITEM[0].ISBG == 1){
          this.drback.saveBGUndo("bginfo");
          this.SELECT_ITEM[0].BGTYPE = cl;
          this.drback.updateBackground(this.SELECT_ITEM[0]);
        }else{
          this.drback.saveUndo("info");
          this.SELECT_ITEM[0].BGTYPE = cl;
          this.drback.updateComponent();
        }
      },

      changecomponenttype(cl){
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].COMPONENT_TYPE = cl;
        this.drback.updateComponent();
      },

      bgcolorcallback(cl){
        if(this.SELECT_ITEM[0].ISBG == 1){
          this.drback.saveBGUndo("bginfo");
          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");
          this.drback.updateBackground(this.SELECT_ITEM[0]);
        }else{
          this.drback.saveUndo("info");
          this.SELECT_ITEM[0].BGCOLOR = String(cl).replace("#","");
          this.drback.updateComponent();
        }
      },

      textcolorcallback(cl){
        this.drback.saveUndo("info");
        this.SELECT_ITEM[0].TEXTCOLOR = String(cl).replace("#","");
        this.drback.updateComponent();
      },


      //DRBackground가 호출함.
      colorupdate(){
        try{
          this.$refs.bgcolor.updatecolor(this.SELECT_ITEM[0].BGCOLOR);
          this.$refs.textcolor.updatecolor(this.SELECT_ITEM[0].TEXTCOLOR);
        // eslint-disable-next-line no-empty
        }catch(e){
        }
        //이미지
        this.uploadFile = null;
        this.uploadFile = this.SELECT_ITEM[0].LOCALIMG;
        this.$forceUpdate();
      },

      //DRBackground가 호출함.
      selectitem(item){
        // 기존 배열을 완전히 비우고 새 아이템 추가
        this.SELECT_ITEM.splice(0, this.SELECT_ITEM.length);
        this.SELECT_ITEM.push(item);
      },

      //DRBackground가 호출함. true면 앞면 false면 뒷면
      selectface(flag){
        console.log("select face : " + flag);
        const edit_div_line  = document.getElementById("edit_div_line");
        edit_div_line.style.border = "3px #4e6ef7 solid";
      },

      //명찰의 앞면 뒷면 선택에 따른 미리보기 셋팅
      setFace(){
        //BG초기화
        this.drback.clearBackground();
        this.createComponent(this.drback, this.SELECT_DESIGN.COMPONENT.data);
      },

      createComponent(bg, list){

        //컴포넌트 생성
        list.forEach(element => {
          
          const model = new DRModel();
          model.ADMIN_IDX     = element.ADMIN_IDX;
          model.EVENT_IDX     = element.EVENT_IDX;
          model.STEP_IDX      = element.STEP_IDX;
          model.IMG           = element.IMG;
          model.LOCALIMG      = null;
          model.ISBG          = element.ISBG;
          model.ISFLIP        = element.ISFLIP;
          model.BGTYPE        = element.BGTYPE;
          model.BGCOLOR       = element.BGCOLOR;
          model.TEXTCOLOR     = element.TEXTCOLOR;
          model.TEXTSIZE      = element.TEXTSIZE;
          model.TEXTFONT      = element.TEXTFONT;
          model.TEXTVALUE     = element.TEXTVALUE;
          model.TEXTALIGN     = element.TEXTALIGN;
          model.TEXTMATCH     = element.TEXTMATCH;
          model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
          model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
          model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
          model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
          model.ROTATE        = element.ROTATE || 0;

          model.TEMP_POSX   = model.LAYOUT_POSX;
          model.TEMP_POSY   = model.LAYOUT_POSY;
          model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
          model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

          model.ZINDEX          = element.ZINDEX;
          model.COMPONENT_TYPE  = element.COMPONENT_TYPE;

          //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
          if(element.ISBG == undefined || element.ISBG == null){
            if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
              model.ISBG = 1; //bg
              //bg는 this.drback에 직접 처리
              bg.updateBackground(model);
              return;
            }else{
              model.ISBG = 0;
              if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                  model.COMPONENT_TYPE = 1; //text
                }else{
                  model.COMPONENT_TYPE = 0; //image
                }
              }
            } 
          }

          if(element.ISBG == 1){
              bg.updateBackground(model);
              return;
          }

          //컴포넌트 객체 생성.
          const component = new DRComponent(model, this.MATCHTYPELIST, false);
          bg.addComponent(component, false);

        });

      },

      templatelayout(){
        
      },

      addcomponent(){
        const cm = new DRModel();
        const cp = new DRComponent(cm, this.MATCHTYPELIST, false);
        this.drback.addComponent(cp, true);
        cp.setMatchTextValue();
      },

      savedesign(){

        //로컬이미지가 있다면 저장 불가.
        var flag = true;
        if(this.drback.model.LOCALIMG != null){
          flag = false;
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }
        for(var j=0;j<this.drback.component_list.length;j++){
          if(this.drback.component_list[j].model.LOCALIMG != null){
            flag = false;
            break;
          }
        }
        if(!flag){
          this.$alert(this.$t('design_msg2'));
          return;
        }

        //뉴라인 특수문자 컨버트 처리
        this.drback.component_list.forEach(cm=>{
            //if(cm.model.COMPONENT_TYPE == 1 && cm.model.TEXTMATCH == "INPUT"){
            if(cm.model.COMPONENT_TYPE == 1){
              cm.model.TEXTVALUE = cm.model.TEXTVALUE.replaceAll("\n", "\\n");
            }
        });

        //객체를 JSON으로 변환하는거 같은데 요고 바꾸자
        var temp_obj  = JSON.parse('{"data":[]}');
        //배경 컴포넌트 넣어주고
        temp_obj["data"].push(this.drback.model);
        this.drback.component_list.forEach(cm=>{
          temp_obj["data"].push(cm.model);
        });

        if(this.PARENT_ITEM.IDX == undefined){
          //신규
          this.$http.post(this.$host+'/api/LayoutInsert',
            {
                ADMIN_IDX: this.PARENT_ITEM.ADMIN_IDX
              , LAYOUT_NAME: escape(this.PARENT_ITEM.LAYOUT_NAME)
              , COMPONENT_WIDTH: this.DISPLAY_WIDTH
              , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
              , COMPONENT: escape(JSON.stringify(temp_obj))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.SELECT_DESIGN.COMPONENT   = temp_obj;

              this.$alert(this.$t('adminlayout_label3')).then(()=>{
                this.loadpage(1);
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
          });
          
        }else{
          //업데이트
          this.$http.post(this.$host+'/api/LayoutUpdate',
            {
                ADMIN_IDX: this.PARENT_ITEM.ADMIN_IDX
              , IDX: this.PARENT_ITEM.IDX
              , LAYOUT_NAME: escape(this.PARENT_ITEM.LAYOUT_NAME)
              , COMPONENT_WIDTH: this.DISPLAY_WIDTH
              , COMPONENT_HEIGHT: this.DISPLAY_HEIGHT
              , COMPONENT: escape(JSON.stringify(temp_obj))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.SELECT_DESIGN.COMPONENT   = temp_obj;
              this.showSaveSnackbar = true;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
          });
          
        }

      },

      deletedesign(){
        this.drback.removeComponent();
      },

      deleteall(){

          this.$confirm(this.$t('design_msg4'))
          .then(() => {

            this.$http.post(this.$host+'/api/LayoutDelete',
            {
                ADMIN_IDX : this.PARENT_ITEM.ADMIN_IDX
              , IDX : this.PARENT_ITEM.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('design_msg5')).then(()=>{
                //BG초기화
                if(this.drback != null){
                  this.drback.clearBackground();
                }
                this.SELECT_DESIGN = null;
                this.loadpage(1);

              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }            
              
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_fail"));
          });      


          });


      },

      changefile(){
        var file = this.uploadFile;
        if (file && file.type.match(/^image\/(png|jpeg)$/)) {

          //배경도 언두 처리 해줘야 하겠지..
          if(this.SELECT_ITEM[0].ISBG == 1){
            this.drback.saveBGUndo("bginfo");
          }else{
            //미리 undo를 백업해야함.
            this.drback.saveUndo("info");
          }

          var temp = window.URL.createObjectURL(file) //로컬 파일 경로를 가지고 이미지를 보여준다.
          this.SELECT_ITEM[0].IMG = temp;
          this.SELECT_ITEM[0].LOCALIMG = file; //blob 타입
          //갱신
          if(this.SELECT_ITEM[0].ISBG == 1){
            this.drback.updateBackground(this.SELECT_ITEM[0]);
          }else{
            this.drback.updateComponent();
          }
        }
      },

      uploadimage(){

        if(this.SELECT_ITEM[0].LOCALIMG == null){
          this.$alert(this.$t('design_msg7'));
          return;
        }

        const formData = new FormData();
        formData.append("FOLDER",     "layout");
        formData.append("customfile", this.SELECT_ITEM[0].LOCALIMG);
        this.$http.post(this.$host+'/api/UploadImage', formData, {
          headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
        })
        .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            //성공
            const fileurl = result.data.resultData[0].fileurl;
            
            //변경
            this.SELECT_ITEM[0].IMG = fileurl;
            this.SELECT_ITEM[0].LOCALIMG = null;

            //갱신
            if(this.SELECT_ITEM[0].ISBG == 1){
              this.drback.updateBackground(this.SELECT_ITEM[0]);
            }else{
              this.drback.updateComponent();
            }
            this.uploadFile = null;

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
        });

      },

      //검색
      search_run(){
        this.loadpage(1);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
          this.PARENT_ITEM = {};

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/LayoutList',
            {
                ADMIN_IDX : this.$session.get("ADMIN_IDX")
              , EVENT_IDX : this.SEARCH_EVENT_IDX
              , search_type:this.search_type
              , search_keyword: escape(this.search_keyword)
              , page: this.page
              , pagerow: 20
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.totalcnt = result.data.totalcnt;
              this.makepaging();
              const list = result.data.resultData;
              this.items.splice(0, this.items.length);   //데이터 초기화
              list.forEach(element => {
                  this.items.push(element); 
              });
              this.loading = false;
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },

      loaddetail(item){
          
          this.PARENT_ITEM = item;

          this.$http.post(this.$host+'/api/LayoutDetail',
            {
                ADMIN_IDX : this.PARENT_ITEM.ADMIN_IDX
              , IDX : this.PARENT_ITEM.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              //edit_div에 DRBackground컴포넌트를 넣어준다.
              var edit_div = document.getElementById("edit_div");
              while ( edit_div.hasChildNodes() ) {
                edit_div.removeChild( edit_div.firstChild ); 
              }

              const bg = new DRModel();
              var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
              this.SELECT_DESIGN = tempobj[0];
              
              this.DISPLAY_WIDTH  = this.SELECT_DESIGN.COMPONENT_WIDTH;
              this.DISPLAY_HEIGHT = this.SELECT_DESIGN.COMPONENT_HEIGHT;

              bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH ;
              bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
              bg.LAYOUT_POSX    = 0;
              bg.LAYOUT_POSY    = 0;
              bg.ISBG           = 1;  //bg
              bg.COMPONENT_TYPE = 0; 
              bg.BGTYPE = 0;
              bg.BGCOLOR = "FFFFFFFF";
              bg.TEXTCOLOR = "000000FF";
              bg.TEXTALIGN = "CENTER";
              bg.TEXTFONT = "나눔고딕";
              bg.TEXTSIZE = 20;
              bg.TEXTMATCH = "INPUT";
              bg.TEXTVALUE = "";
              bg.TEMP_POSX = 0;
              bg.TEMP_POSY = 0;
              bg.TEMP_WIDTH = this.DISPLAY_WIDTH;
              bg.TEMP_HEIGHT = this.DISPLAY_HEIGHT;
              bg.ROTATE = 0;
              bg.LOCALIMG = null;
              
              this.SELECT_ITEM.splice(0, 1, bg);
              this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
              edit_div.appendChild(this.drback);
              
              this.setFace();

              

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
          });

      },


      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
        }
        this.loadpage(1);
      },

      //base64 이미지 데이터를 파일로 변환
      dataURLtoFile(dataurl, fileName){
 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], fileName, {type:mime});

      },
      

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/LayoutDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },      

      selectlayout_com(item){

          //부모뷰의 edit_div에 넣는다.
          this.$http.post(this.$host+'/api/LayoutDetail',
            {
                ADMIN_IDX : item.ADMIN_IDX
              , IDX : item.IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
              var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
              this.DISPLAY_WIDTH  = tempobj[0].COMPONENT_WIDTH;
              this.DISPLAY_HEIGHT = tempobj[0].COMPONENT_HEIGHT;

              //edit_div에 DRBackground컴포넌트를 넣어준다.
              var edit_div = document.getElementById("edit_div");
              while ( edit_div.hasChildNodes() ) {
                edit_div.removeChild( edit_div.firstChild ); 
              }
              const bg = new DRModel();
              bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
              bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
              bg.LAYOUT_POSX    = 0;
              bg.LAYOUT_POSY    = 0;
              bg.ISBG           = 1;  //bg
              bg.COMPONENT_TYPE = 0; 
              bg.BGTYPE = 0;
              bg.BGCOLOR = "FFFFFFFF";
              this.drback  = new DRBackground(bg, this.SELECT_ITEM, this, true);
              edit_div.appendChild(this.drback);
              
              this.SELECT_ITEM.splice(0, 1, bg);
              this.SELECT_DESIGN = tempobj[0];
              this.setFace();

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              //BG초기화
              this.drback.clearBackground();
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              //BG초기화
              this.drback.clearBackground();
          });

      },

    },

    beforeRouteLeave (to, from, next) {
      if(this.drback != null && this.drback != undefined){
        var undocnt1 = this.drback.getUndoSize();
        if(undocnt1 > 0){
          this.$confirm(this.$t('design_msg10'))
          .then(() => {
            next();
          });
        }else{
          next();
        }
      }else{
        next();
      }
    },

    mounted(){

      if(this.$session.get("GRADE") < 99){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      // Del 키 이벤트 리스너 등록
      window.addEventListener('keydown', this.handleKeyDown);

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
        return;
      }
      
      

      //폰트 읽기
      this.$http.post(this.$host+'/api/FontList',{
        search_keyword:""
      },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
      .then((result)=>{
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

              const list = result.data.resultData;
              list.forEach(element => {
                //폰트 등록
                var temp_font = new FontFace(element.NAME, "url('"+element.FONTURL+"')");
                document.fonts.add(temp_font);
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((error)=>{
          
      });


    },

    beforeDestroy(){
      // Del 키 이벤트 리스너 제거
      window.removeEventListener('keydown', this.handleKeyDown);
    },



    computed: {
    },

    watch: {

    },

    data () {
      
      return {
        //dr background
        drback: null,

        //필수 페이징 파라메터
        totalcnt : 0,       //전체 아이템 개수
        page : 0,
        maxpage : 0,        //전체 페이지 개수
        bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
        subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
        loading : false,    //로딩 표시
        pagerow : 20,
        
        //파일 업로드
        uploadFile : null,

        headers: [
          {text: '템플릿명', align: 'center', sortable: false, value: 'LAYOUT_NAME'},
          {text: '너비', align: 'center', sortable: false, value: 'COMPONENT_WIDTH'},
          {text: '높이', align: 'center', sortable: false, value: 'COMPONENT_HEIGHT'},
          {text: '디자인', align: 'center', sortable: false, value: 'detail'},
        ],

        search_type : 'LAYOUT_NAME',   
        search_keyword : '',
        
        items: [],
        SELECT_ITEM: [{
          ISBG: 1,
          BGCOLOR: "FFFFFFFF",
          TEXTCOLOR: "000000FF",
          TEXTALIGN: "CENTER",
          TEXTFONT: "나눔고딕",
          TEXTSIZE: 20,
          TEXTMATCH: "INPUT",
          TEXTVALUE: "",
          TEMP_POSX: 0,
          TEMP_POSY: 0,
          LAYOUT_POSX: 0,
          LAYOUT_POSY: 0,
          LAYOUT_WIDTH: 384,
          LAYOUT_HEIGHT: 463,
          ROTATE: 0,
          BGTYPE: 0,
          COMPONENT_TYPE: 0,
          LOCALIMG: null
        }],
        DISPLAY_WIDTH:384,
        DISPLAY_HEIGHT:463,

        PARENT_ITEM: {},
        SELECT_DESIGN:null, //선택된 행사의 명찰디자인 객체

        BGTYPELIST: [
            {name:'컬러', name2:"Color",   value:0}
          , {name:'이미지', name2:"Image", value:1}
        ],

        ALIGNTYPELIST: [
            {name:'왼쪽',  name2:"Left",  value:"LEFT"}
          , {name:'오른쪽', name2:"Right", value:"RIGHT"}
          , {name:'가운데', name2:"Center", value:"CENTER"}
        ],

        COMPONENTTYPELIST: [
            {name:'텍스트', name2:"Text", value:1}
          , {name:'이미지', name2:"Image", value:0}
          , {name:'QR코드', name2:"QRCode", value:2}
          , {name:'포토',   name2:"Photo", value:3}
          , {name:'바코드', name2:"Barcode", value:4}
        ],

        MATCHTYPELIST: [
            {name:'직접입력',  name2:"Input",   value:"INPUT"}
        ],

        showSaveSnackbar: false,

      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  
  li {
    display: inline;
    
  }

  .pagination{
    margin: 0px;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    color-adjust: exact !important;
  }

  @media print {
      * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
      }
  }

</style>
